// extracted by mini-css-extract-plugin
export default {"listWrapper":"styles_listWrapper__opMWp","item":"styles_item__235P6"};